import { forwardRef } from "react";
import classNames from "classnames";
import { Button } from "../Button";
import { useTranslation } from "react-i18next";

import { noop } from "@helpers/common";
import { ReactComponent as IconClose } from "../../assets/ic-close.svg";
import { ReactComponent as SearchIcon } from "../../assets/ic-search.svg";

import styles from "./index.module.scss";

const SearchInput = forwardRef(
  (
    {
      wrapperClassName,
      placeholder,
      children,
      onChange,
      inputValue,
      bordered,
      withClearButton,
      onKeyDown = noop,
      onResetClick = noop,
      onBlur = noop,
      onFocus = noop,
    },
    ref,
  ) => {
    const { t } = useTranslation("placeholders");

    return (
      <div
        ref={ref}
        className={classNames(
          "text-body-1 text-primary",
          styles.search,
          bordered && styles.bordered,
          wrapperClassName,
        )}
      >
        <div className="d-flex w-100">
          <SearchIcon
            className={classNames(
              "d-flex me-2 flex-shrink-0",
              styles.searchIcon,
            )}
          />
          <input
            className={classNames(
              "btn-resetStyle d-flex text-primary",
              styles.input,
            )}
            type="text"
            placeholder={t(placeholder)}
            onChange={onChange}
            value={inputValue}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
          />
          {inputValue && withClearButton && (
            <Button
              className="btn-resetStyle d-flex align-self-center"
              onClick={onResetClick}
            >
              <IconClose
                className={classNames("text-tertiary", styles.close)}
              />
            </Button>
          )}
        </div>
        {children}
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
